import { ICloudStorageProvider } from "../../domain/Upload/i-cloud-storage-provider";
import { HttpService } from "../http/http";
import { IUploadFile } from "../../domain/Upload/i-upload-file";
import { TenantStorageOption } from "../../domain/tenant-storage-option";
import { OvhUploadFile } from "./ovh-upload-file";
import { HttpClient } from "@angular/common/http";
import { Auth } from "../auth";

export class OvhCloudProvider implements ICloudStorageProvider {
  private _ovhConfig: IOvhConfig;
  private hasInited = false;

  constructor(
    private http: HttpService,
    private httpClient: HttpClient,
    private auth: Auth,
  ) {}

  // tslint:disable-next-line:max-line-length
  createFile(
    id: string,
    file: File,
    objectKeyPath: string,
    uploadType:
      | "originalMediaContent"
      | "mediaContent"
      | "thumbnail"
      | "graphics"
      | "graphicsThumbnails"
      | "graphicsFont"
      | "graphicsSampleVideo",
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    if (this.hasInited === false) {
      throw new Error(
        "OvhCloudProvider -> createFile -> the provider hasn't been inited!",
      );
    }
    const bucketName = this.getBucketName(uploadType);
    // const fileUrl = `${this._ovhConfig.StorageEndpointUrl}/${bucketName}/${objectKeyPath}`;
    // tslint:disable-next-line:max-line-length
    return new OvhUploadFile(
      id,
      file,
      this._ovhConfig.StorageEndpointUrl,
      bucketName,
      objectKeyPath.trim().toLowerCase(),
      this._ovhConfig.ChunkSize,
      customData,
      notifyServer,
      new Date(),
      this.httpClient,
      this.http,
      this.auth,
    );
  }

  createFileForTenantBucket(
    id: string,
    file: File,
    s3Filename: string,
    tenantStorageOption: TenantStorageOption,
  ): Promise<IUploadFile> {
    throw new Error(
      "OvhCloudProvider->Batch import is not implemented for OVH cloud provider!",
    );
  }

  // tslint:disable-next-line:max-line-length
  getBucketName(
    uploadType:
      | "originalMediaContent"
      | "mediaContent"
      | "thumbnail"
      | "graphics"
      | "graphicsThumbnails"
      | "graphicsFont"
      | "graphicsSampleVideo"
      | "videoLogo",
  ): string {
    switch (uploadType) {
      case "thumbnail":
      case "graphicsThumbnails":
        return this._ovhConfig.PublicBucketName;
      case "originalMediaContent":
      case "mediaContent":
      case "graphics":
      case "graphicsFont":
      case "videoLogo":
      case "graphicsSampleVideo":
        return this._ovhConfig.PrivateBucketName;
    }
  }

  async init() {
    if (this.hasInited) {
      return;
    }

    this._ovhConfig = await this.http.get("ovh");
    console.log("ovh-cloud-provider->init(),ovhConfig", this._ovhConfig);

    this.hasInited = true;
  }

  isCustomServiceUrl(): boolean {
    return false;
  }

  createOriginalMediaFile(
    id: string,
    file: File,
    fileName: string,
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    return undefined;
  }

  createTranscodedFile(
    id: string,
    file: File,
    fileName: string,
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    throw new Error(
      "OvhCloudProvider -> createTranscodedFile is not supported yet.",
    );
  }
}

interface IOvhConfig {
  PublicBucketName: string;
  PrivateBucketName: string;
  StorageEndpointUrl: string;
  ChunkSize: number;
}
